import { StationMixer } from '@linktivity/sagano';

import config from '../config';

const stationMixer = new StationMixer.StationMixerApi(config);

export default stationMixer;
